import React from 'react';
import bgImg from '../../assets/img/skill_bg.jpg';
import leftImg from '../../assets/img/skill_img.jpg';
import SkillBar from './SkillBar';

function SkillSet() {
    return (
        <section className="skill-wrapper section-padding pt-0">
            <div className="container">
                <div
                    className="skill-bg pt-100 pb-100 bg-center bg-cover bg-overlay text-white"
                    style={{
                        backgroundImage: `url(${bgImg})`,
                    }}
                >
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-12 text-center d-none d-xl-block">
                            <img src={leftImg} className="mlm-100" alt="" />
                        </div>
                        <div className="col-xl-6 offset-1 offset-xl-0 col-10 pr-lg-5">
                            <div className="block-contents">
                                <span>Our Skill set</span>
                                <h1>Certifications</h1>
                                <h4>
                                    Vedant Technology is committed to quality, safety, and environmental responsibility. We are working towards implementing internationally recognized management systems and certifications.

                                </h4>
                            </div>
                            <li>
                                - ISO 9001 – Quality Management System
                            </li>
                            <li>- ISO 14001 – Environmental Management System</li>
                            <li>- ISO 45001 – Occupational Health and Safety Management System</li>
                            <li>- IATF 16949 – Automotive Quality Management System (Planned)</li>
                            {/* PROGRESS BARS */}
                            {/* <SkillBar heading="ISO 9001 – Quality Management System
" progress="70%" />
                            <SkillBar heading="ISO 14001 – Environmental Management System
" progress="90%" />
                            <SkillBar heading="ISO 45001 – Occupational Health and Safety Management System
" progress="85%" /> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SkillSet;
